import React, { VoidFunctionComponent } from "react";
const MADE_IN_FRANCE_LABEL = "Fabrique en France";
const whiteBackgroundColor = ["white", "#fff", "#ffffff"];

interface Props {
    title: string;
    color: string;
    backgroundColor: string;
}

export const Tag: VoidFunctionComponent<Props> = ({ title, color, backgroundColor }) => {
    const isMadeInFrance = title === MADE_IN_FRANCE_LABEL;
    const containerStyle = whiteBackgroundColor.includes(
        backgroundColor.toLowerCase()
    )
        ? {
            backgroundColor: backgroundColor,
            color: color,
            border: `solid 1px ${color}`,
        }
        : { backgroundColor: backgroundColor, color: color };
    return isMadeInFrance ? (
        <div className="product-tag france">
            <p>Fabriqué en France</p>
            <div className="flag">
                <hr />
                <hr />
                <hr />
            </div>
        </div>
    ) : (
        <div className="product-tag" style={containerStyle}>
            <p dangerouslySetInnerHTML={{ __html: title }}></p>
        </div>
    );
};